import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { VendorAdminService } from "../../../services/api/vendor-admin.service";
import { VendorAdminActions } from "../../actions/vendor-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class VendorDeleteInternationalBankAccountEffects {
	remove = createEffect(() =>
		this.actions.pipe(
			ofType(VendorAdminActions.deleteInternationalAccount.delete),
			switchMap((action) =>
				this.vendorAdminService.deleteInternationalAccount(action.id).pipe(
					map(() => VendorAdminActions.deleteInternationalAccount.deleteSuccess()),
					catchError((error) =>
						of(
							VendorAdminActions.deleteInternationalAccount.deleteFail(
								new FailState(error)
							)
						)
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private vendorAdminService: VendorAdminService
	) {}
}
